import { generateQueryParamsString, Request } from '@/lib/http';
import store from '@/store';
import AuthEnum from '../lib/enums/auth-enum';

const baseURL = '/api/dashboards';

export default {
  getDashboards(url) {
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/collection/${url}`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
  getDashboard(dashboardId, query) {
    const queryString = generateQueryParamsString(query);
    const tenantId = store.getters.tenant.id;
    const request = new Request(`${baseURL}/${tenantId}/${dashboardId}${queryString}`, {
      authType: AuthEnum.TENANT,
    });
    return request.send();
  },
};
